import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection, FeatureCard } from '../../components/footer/ContentSection';
import { CTASection } from '../../components/footer/CTASection';

export const SafetyGuidelinesPage: React.FC = () => {
  const theme = useTheme();

  const guidelines = [
    {
      icon: "🔍",
      title: "Verify Identity",
      description: "Always verify the identity of your caregiver before allowing them into your home or beginning treatment.",
    },
    {
      icon: "🏠",
      title: "Safe Environment",
      description: "Ensure your home is safe and well-lit for the appointment. Remove any hazards and provide a comfortable space for treatment.",
    },
    {
      icon: "📞",
      title: "Emergency Contacts",
      description: "Keep emergency contact information readily available and inform someone about your appointment.",
    },
    {
      icon: "📋",
      title: "Medical Information",
      description: "Provide accurate medical history and current medications to ensure safe and effective treatment.",
    },
  ];

  return (
    <PageLayout
      title="Safety Guidelines"
      subtitle="Important safety guidelines for patients and caregivers to ensure a safe and positive experience."
      breadcrumbs={[
        { label: "Support", href: "/support" },
        { label: "Safety Guidelines" },
      ]}
    >
      {/* Guidelines */}
      <ContentSection
        title="Safety Guidelines"
        subtitle="Follow these guidelines to ensure a safe and positive experience for everyone."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {guidelines.map((guideline, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    fontSize: '3rem',
                    mb: 2,
                  }}
                >
                  {guideline.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: theme.palette.text.primary,
                  }}
                >
                  {guideline.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                  }}
                >
                  {guideline.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Questions About Safety?"
        subtitle="If you have any safety concerns or questions, please contact our support team immediately."
        primaryButton={{
          text: "Contact Support",
          href: "/contact",
        }}
        secondaryButton={{
          text: "Report an Issue",
          href: "/report",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
